import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ReportColumnFiltersRoute } from '../../routing'

export  class ReportColumnFiltersPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ReportColumnFiltersRoute />
            </Fragment>
        )
    }
}
